module.exports = __webpack_public_path__ + "static/media/map_marker.b9245c9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/map_marker.svg
// module id = 1846
// module chunks = 0